<template>
  <div class="home-wrap" v-if="Object.keys(info).length > 0">
    <DWHead />
    <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
      <van-swipe :autoplay="4000">
        <van-swipe-item v-for="(item, index) in bannerImages" :key="index" @click="bannerHandle(item)">
          <van-image lazy-load :src="item.imgUrl" fit="fill">
            <template v-slot:error>加载失败</template>
          </van-image>
        </van-swipe-item>
      </van-swipe>

      <van-grid :column-num="buttonList.length > 3 ? 4 : buttonList.length" :border="false" v-if="buttonList.length > 0"
        icon-size="46">
        <van-grid-item v-for="value in buttonList" :key="value.id" :icon="value.backgroundIconUrl" :text="value.title"
          @click="buttonHandle(value)" />
      </van-grid>

      <van-swipe :autoplay="4000">
        <van-swipe-item v-for="(item, index) in adImages" :key="index" @click="bannerHandle(item)">
          <van-image lazy-load :src="item.imgUrl" fit="fill">
            <template v-slot:error>加载失败</template>
          </van-image>
        </van-swipe-item>
      </van-swipe>

      <DWHomeLiveNoticeSwiper v-if="
        findListModal('zhibyg') &&
        findListModal('zhibyg').courselist.length > 0
      " :modal="findListModal('zhibyg')" />
      <DWHomeNormalList v-if="
        findListModal('zhibhg') &&
        findListModal('zhibhg').courselist.length > 0
      " :modal="findListModal('zhibhg')" style="padding-bottom: 20px;" />

      <div v-if="showSupport===2" style="text-align:center;padding-bottom: 20px;color: #999999;">药大咖医桥云 提供技术支持</div>
      <Top />
    </van-pull-refresh>
  </div>

  <LoddingElement v-else />
</template>

<script>
import apis from "@/config/apis";
import { localDB } from "@/config/storage";
import { getEnv } from "@/config/utils";
import share from "@/mixins/share";
import { getCorpCode } from "@/config/yqy";

import yqyapis from "@/config/yqyapis";
import { GetBdMapToTxMapLatLng } from "@/config/latlng";
import mapLocation from "@/mixins/mapLocation";


export default {
  name: "Home",
  mixins: [share],
  data: () => ({
    info: {},
    gotop: false,
    isLoading: false,
    showSupport: 2,

    bannerImages: [

    ],
    adImages: [

    ],
    buttonList: [

    ],
    corpCode: "",
  }),
  created() {
    this.corpCode = getCorpCode();
    this.gethomeInfo();
  },

  computed: {
    // 根据传入的列表大类code返回对应的modal数据
    findListModal() {
      return code => {
        if (this.info.categorylist && this.info.categorylist.length > 0) {
          return this.info.categorylist.filter(item => item.code === code)[0];
        }
        return undefined;
      };
    }
  },
  methods: {
    // 获取首页信息
    async gethomeInfo() {

      try {
        const resp = await apis.common.getHomeDWInfo();
        if (resp.success === "ok") {

          if (resp.bannerList1) {
            let bannerImages = [];
            for (let i = 0; i < resp.bannerList1.length; i++) {
              bannerImages.push(resp.bannerList1[i]);
            }
            this.bannerImages = bannerImages;
          }
          if (resp.bannerList2) {
            let adImages = [];
            for (let i = 0; i < resp.bannerList2.length; i++) {
              adImages.push(resp.bannerList2[i]);
            }
            this.adImages = adImages;
          }

          if (resp.buttonList) {
            let buttonList = [];
            for (let i = 0; i < resp.buttonList.length; i++) {
              buttonList.push(resp.buttonList[i]);
            }
            this.buttonList = buttonList;
          }

          if (resp.showSupport) {
            this.showSupport = resp.showSupport;
          }


          this.info = { ...resp };
          this.isLoading = false;
          let token = localDB.getItem("TOKEN");

          if (token && getEnv() !== "h5") {
            // 获取阅读id
            let shars = {};
            shars.shareId = this.$route.query.shareId || "0";
            shars.bizId = this.$route.query.bizId || "0";
            let resShare = resp.share ? resp.share : {};
            let url = window.location.href.split("?")[0];
            if (this.corpCode) {
              url = url + "?corpCode=" + this.corpCode
            }
            this.onDWShare({
              link: url, desc: resShare.shareContent, imgUrl: resShare.shareImgUrl, title: resShare.shareTitle
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },


    bannerHandle(data) {
      if (data.url) {
        window.location.href = data.url;
      }
    },



    async buttonHandle(data) {
      if (data.pageType === 1) {
        if (data.v) {
          this.$router.push({
            path: "/dw/showimg",
            query: { url: data.v, title: data.title }
          });
        }
      } else if (data.pageType === 2) {
        if (data.v) {
          window.location.href = data.v;
        }
      } else if (data.pageType === 3) {
        if (data.v === "5") {
          const resp = await yqyapis.appPage.getAppPageFunMap({ appPageId: data.id });
          if (resp.success === true) {
            {
              if (resp.data) {
                let lt = GetBdMapToTxMapLatLng(resp.data.lat, resp.data.lng);
                mapLocation.openLocation({
                  latitude: lt.lat, // 纬度，浮点数，范围为90 ~ -90
                  longitude: lt.lng, // 经度，浮点数，范围为180 ~ -180。
                  name: resp.data.name, // 位置名
                  address: resp.data.address, // 地址详情说明
                  scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
                  infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
                });
              }
            }
          }
        }
      }
    },

    onRefresh() {
      this.gethomeInfo();
    }
  }
};
</script>

<style lang="scss">
.home-wrap {
  overflow: hidden;
}

.HomeBanner {
  width: 100%;
  overflow: hidden;
}

.AdBanner {
  width: 100%;
  overflow: hidden;
}
</style>
